import { Stack, Container, Skeleton, Box, Grid, Typography, Tabs, Tab, Button, Menu, Avatar } from '@mui/material'
import React from 'react'
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import styles from '../../Artist.module.css'
import placeholder from '../../../../assets/placeholder_artist.jpg';
import { Link, useParams } from 'react-router-dom'
import { useGetArtistQuery } from '../../../../api/artistApiSlice';
import { useGetUserQuery, useLikeByTypeMutation } from '../../../../api/userApiSlice';
import AMBadgeListenIn from '../../../../assets/AMBadgeListenIn.svg';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import YouTubeIcon from '@mui/icons-material/YouTube';
import TwitchIconpng from '../../../../assets/TwitchGlitchWhite.png'
import PlayTopTracksButton from '../../../utils/PlayTopTracksButton';
import { useState } from 'react'
import { useDispatch } from 'react-redux';
import { setShowSubscribe } from '../../../../actions/mainSlice';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import parse from 'html-react-parser'

const chipStyle = { 
    color:'#fff',
    height: '2.6vh',
    borderRadius: '1.3vh',
    fontFamily: 'Montserrat',
    fontSize: '0.8rem',
    minWidth: '50px',
    mr: 1,
    '& span': {padding: '0 18px'}
}


const ArtistSideMenuMobile = () => {
    
    let { id } = useParams()
    const dispatch = useDispatch()
    const [likeArtist] = useLikeByTypeMutation()
    const [mode, setMode] = useState(0)
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const openMenu = Boolean(anchorEl)

    const handleClickOpen = () => {
        dispatch(setShowSubscribe({showSubscribe: true}))
    }

    const handleClickShare = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget)
    }

    const handleCloseMenu = () => {
        setAnchorEl(null)
    }

    const {
        data: user,
        refetch: refetchUser
    } = useGetUserQuery({})

    const {
        data
    } = useGetArtistQuery({id})

    const showBio = () => {
		setMode(0)
	}

    const showMore = () => {
		setMode(1)
	}

    const likeArtistById = async (ID: string) => {
        try {
            const like = await likeArtist({target_id: ID, type: 'artist'}).unwrap()
            refetchUser()
            if(like) {
                console.log('TODO: Use like')
            }
        } catch (error) {
            handleClickOpen()
        }
    }

    return <Grid size={{xs: 12}} sx={{height: '100%', borderRadius: '16px'}}>
        <Stack 
            spacing={0} 
            sx={{
                height: '100%',
                borderRadius: '16px',
                overflow: 'hidden',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundImage: `url(${data && data.apple_artwork_url ? data.apple_artwork_url.replace("cw.png","cc.png").replace("{w}","1200").replace("{h}","800") : data && data.avatar_url ? data.avatar_url.replace("cw.png","cc.png").replace("{w}","1200").replace("{h}","800") : placeholder})`
            }}
        >
            <Container sx={{backdropFilter: 'blur(20px)  brightness(70%)', height: '100%', width: '100%', paddingTop: '0!important', position: 'relative', overflow: 'hidden'}}>
                <Stack direction={'column'} sx={{height: '100%'}}>

                    <Stack direction="row" alignItems="center" sx={{pt: 2, pb: 0, }}>
                        <Typography variant='h3' sx={{fontSize: '1.4em', whiteSpace: 'nowrap', fontWeight: 800, textOverflow: 'ellipsis', overflow: 'hidden', maxWidth: '70%' }}>{data ? data.artist_name : '--'}</Typography>
                        <Link to={data ? data.apple_url : '#'} target='blank' style={{position: 'absolute', right: '8px', top: '8px'}}><img alt='apple music link' src={AMBadgeListenIn} /></Link>  
                    </Stack>
                    <Stack direction={'row'} sx={{ height: '55px', mt: 2}}>
                        <Tabs value={mode} indicatorColor='secondary' textColor='secondary'>
                            <Tab key={'Bio'} label={'Bio'} value={0} onClick={showBio} sx={chipStyle}/>
                            <Tab key={'Dates'} label={'Dates'} value={1} onClick={showMore} sx={chipStyle}/>
                        </Tabs>
                        <Stack direction={'row'} spacing={2} sx={{height: '35px', position: 'absolute', right: '8px'}} >
                            { data 
                                ? <PlayTopTracksButton style={{borderRadius: '16px', backgroundColor: '#00000080', minWidth: '35px', minHeight: '35px', '& svg': {fontSize: '1.4rem'}}} artistId={data._id} /> 
                                : <Button sx={{borderRadius: '16px', backgroundColor: '#00000080', minWidth: '35px', minHeight: '35px'}} ><PlayArrowIcon htmlColor='#ffffff60' sx={{fontSize: '1rem'}}/></Button> 
                            }
                            <Button onClick={() => likeArtistById(data._id)} sx={{ borderRadius: '16px', backgroundColor: '#00000080', minWidth: '35px', minHeight: '35px'}}> <FavoriteIcon htmlColor={data && user && user.likes && user.likes.filter((like: any) => like.target_id === data._id).length > 0 ? '#FF5964' : 'white'} sx={{fontSize: '1rem'}} /> </Button>
                            <Button onClick={handleClickShare} sx={{ borderRadius: '16px', backgroundColor: '#00000080', minWidth: '35px', minHeight: '35px'}}> <ShareIcon htmlColor={'white'} sx={{fontSize: '1rem'}} /> </Button>
                            <Menu
                                id="share-menu"
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                MenuListProps={{
                                'aria-labelledby': 'long-button',
                                }}
                                anchorEl={anchorEl}
                                open={openMenu}
                                onClose={handleCloseMenu}
                                sx={{p: 0}}
                            >
                                <Stack direction={'row'} sx={{}}>
                                    { data && data.twitter_name ? <Button sx={{minWidth: '16px'}}><a href={'https://www.twitter.com/' + data.twitter_name} target='blank'><TwitterIcon htmlColor='black'/></a></Button> : ''}
                                    { data && data.instagram_name ? <Button sx={{minWidth: '16px'}}><a href={'https://www.instagram.com/' + data.instagram_name} target='blank'><InstagramIcon htmlColor='black'/></a></Button> : ''}
                                    { data && data.facebook_name ? <Button sx={{minWidth: '16px'}}><a href={'https://www.facebook.com/' + data.facebook_name} target='blank'><FacebookIcon htmlColor='black'/></a></Button> : ''}
                                    { data && data.youtube_name ? <Button sx={{minWidth: '16px'}}><a href={'https://www.youtube.com/@' + data.youtube_name} target='blank'><YouTubeIcon htmlColor='black'/></a></Button> : ''}
                                    { data && data.twitch_name ? <Button sx={{minWidth: '16px'}}><a href={'https://www.twitch.com/' + data.twitch_name} target='blank'><Avatar sx={{width: '20px', height: '25px'}} variant='square' src={TwitchIconpng} /></a></Button> : ''}
                                </Stack>
                            </Menu>
                        </Stack>
                    </Stack>
                    {
                        data ?
                            mode === 0 
                            ? 
                                <Box sx={{height: '100%'}}>
                                    <div className={styles.head}>{
                                        data.apple_notes_short && data.apple_notes_short.length > 0 
                                        ? parse(data.apple_notes_short)
                                        : "--"
                                    }</div>
                                    <div className={styles.content}>{
                                        data.apple_notes_standard && data.apple_notes_standard.length > 0 
                                        ? parse(data.apple_notes_standard)
                                        : "--"
                                    }</div>
                                </Box>
                            : 
                            'soon'    
                        : <Skeleton variant='rounded' sx={{width: '100%', height: '100%', borderRadius: '16px'}} />
                    }                            
                    </Stack>
                </Container>
            </Stack>
    </Grid>
} 

export default ArtistSideMenuMobile